import './set-public-path'
import GtmService from './gtm'

const gtm = new GtmService()

export const trackApplicationOnload = (user) => gtm.applicationOnload(user)
export const trackPageTransition = (page) => gtm.pageTransition(page)
export const trackCustomEvent = (event, data) => gtm.customEvent(event, data)
